module.exports = __webpack_public_path__ + "img/button-home5.e9db884e.jpeg";